import { common } from './common.en';
import { questionnaire } from './questionnaire.en';
import { navBarTrad } from './navBarTrad.en';
import { profileDef } from './profileDef.en';
import { question } from './question.en';
import { contents } from './contents.en';
import { study } from './study.en';
import { lang } from './lang.en';
import { login } from './login.en';
import { sites } from './sites.en';
import { sequence } from './sequence.en';
import { editorjs } from './editorJs.en';
import { errorMessages } from './error.en';
import { invitation } from './invitation.en';
import { home } from './home.en';
import { translations } from './translations.en';
import { role } from './role.en';
import { randomization } from './randomization.en';
import { stratification } from './stratification.en';
import { profiles } from './profiles.en';
import { deployment } from './deployment.en';
import { exportData } from './dataExport.en';
import { finalParams } from './finalParams.en';
import { InvitationUsers } from './invitationUsers.en';
import { questionnairDependencies } from './questionnairDependencies.en';
import { massCommunication } from './massCommunication.en';
import { resetData } from './dataReset.en';

export const diapasonTradEn = {
  ...common,
  ...questionnaire,
  ...navBarTrad,
  ...profileDef,
  ...question,
  ...study,
  ...lang,
  ...login,
  ...contents,
  ...login,
  ...sites,
  ...editorjs,
  ...invitation,
  ...InvitationUsers,
  ...sequence,
  ...home,
  ...translations,
  ...role,
  ...invitation,
  ...randomization,
  ...stratification,
  ...profiles,
  ...deployment,
  ...exportData,
  ...finalParams,
  ...questionnairDependencies,
  ...massCommunication,
  ...errorMessages,
  ...resetData
};
